import { ff } from '@atlassian/jira-feature-flagging';
import { useUserPropertyObject } from '@atlassian/jira-insights-common';
import { useResource } from '@atlassian/jira-router';
import { nextBestTaskFeatureResource } from '@atlassian/jira-router-resources-next-best-task';
import {
	NEXT_BEST_TASK_PANEL_ISDISABLED_STATE_UPDATE_DEBOUNCE_MS,
	NEXT_BEST_TASK_PANEL_ISDISABLED_USERPROPERTY_KEY,
} from '../../common/constants';
import { useNextBestTaskContainer } from '../next-best-task-container';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const useNextBestTaskPanel = () => {
	const [
		{ isAutoOpened, isHiddenByUser, isNbtToggleButtonVisible, isOnlyCurrentUserSelected },
		{ setIsAutoOpened, setIsNbtToggleButtonVisible },
	] = useNextBestTaskContainer();

	const [{ value: isNBTPanelDisabledProperty, isLoading }, { save }] = !ff(
		'jira.work-suggestions.remove-nbt-button',
	)
		? // eslint-disable-next-line react-hooks/rules-of-hooks
			useUserPropertyObject<boolean>(NEXT_BEST_TASK_PANEL_ISDISABLED_USERPROPERTY_KEY)
		: [{ value: undefined, isLoading: false }, { save: noop }];

	const { data: isWorkSuggestionsEnabledData } = useResource(nextBestTaskFeatureResource);

	const hasUserOptedIn = !!isWorkSuggestionsEnabledData?.hasUserOptedIn;

	// Replace isControlVisible with after `jira.work-suggestions.remove-nbt-button` FF is removed
	const isControlVisible =
		!ff('jira.work-suggestions.remove-nbt-button') && isOnlyCurrentUserSelected && hasUserOptedIn;

	const isReadyToFetchNBT =
		isOnlyCurrentUserSelected &&
		hasUserOptedIn &&
		(ff('jira.work-suggestions.remove-nbt-button') ? !isHiddenByUser : true);
	const isOpen =
		isReadyToFetchNBT &&
		isAutoOpened &&
		(ff('jira.work-suggestions.remove-nbt-button')
			? !isHiddenByUser
			: !isNBTPanelDisabledProperty?.isDisabled.value && !isLoading);

	// Remove this function after `jira.work-suggestions.remove-nbt-button` FF is removed
	const toggleNBTPanelIsDisabled = () => {
		if (!isAutoOpened) {
			setIsAutoOpened(true);
		}

		save('isDisabled', isOpen, undefined, {
			debounceMs: NEXT_BEST_TASK_PANEL_ISDISABLED_STATE_UPDATE_DEBOUNCE_MS,
		});
	};

	return {
		isControlVisible,
		isReadyToFetchNBT,
		isOpen,
		isAutoOpened,
		isNbtToggleButtonVisible,
		setIsAutoOpened,
		isHiddenByUser,
		setIsNbtToggleButtonVisible,
		onTogglePanelVisibility: toggleNBTPanelIsDisabled,
	};
};
